import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { toastHelper } from '../../util/toastHelper'
import { TasksPanel } from '../tasks/TaskComponent.jsx'
import { Box } from '@mui/material'
import { TaskForm } from '../tasks/TaskForm.jsx'

const initialState = {
	name: '',
	type: '',
	assignedUsers: [],
	ableToView: [],
	priority: 1,
	status: 1,
	comments: '',
	eventTags: [],
}

export const VendorTasksTemplateHeader = (props) => {
	return <div id="event-header">{props.Subject}</div>
}

export const VendorTasksTemplateFooter = () => {
	return <></>
}

export const VendorTasksTemplate = (props) => {
	const dispatch = useDispatch()

	const [currentAction, setCurrentAction] = useState('task-view')
	const [task, setTask] = useState(initialState)

	const handleAddTask = () => {
		// here is the save task logic
		if (!task.name || !task.type) {
			return toastHelper(
				'Please provide a task name and select a type',
				'error'
			)
		}
		// dispatch(postTask({ ...task, eventId: props._id }))

		setTask(initialState)
		setCurrentAction('task-view')
	}

	const handleBack = () => {
		setTask(initialState)
		setCurrentAction('task-view')
	}

	return (
		<>
			{currentAction === 'task-view' ? (
				<div>
					<TasksPanel eventId={props._id} />
					<button
						onClick={() => setCurrentAction('adding-new-task')}
						data-cy="createTaskButton"
					>
						Create new task
					</button>
				</div>
			) : (
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
					}}
				>
					<TaskForm task={task} setTask={setTask} />
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
						}}
					>
						<button onClick={handleBack} data-cy="backButton">
							Back
						</button>
						<button onClick={handleAddTask} data-cy="addTaskButton">
							Add
						</button>
					</Box>
				</Box>
			)}
		</>
	)
}
